export default __webpack_public_path__ + "static/media/close.9766a793.svg";